import { render, staticRenderFns } from "./individual_race_management.vue?vue&type=template&id=0a2a0c9e&scoped=true"
import script from "./individual_race_management.vue?vue&type=script&lang=js"
export * from "./individual_race_management.vue?vue&type=script&lang=js"
import style0 from "./individual_race_management.vue?vue&type=style&index=0&id=0a2a0c9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2a0c9e",
  null
  
)

export default component.exports